import { Brand } from './typings'

const tru: Brand = {
  clientInfo: {
    displayName: 'Synchrony Financial',
    accountNumberLengths: [16],
    footerDisplay: '',
    footerLink: '',
    applicationUrl: 'https://www.synchronybank.com/creditcard/learnmore/',
    dsecApigeeClientId: {
      development: '5OGotii9GbL3xplg5vGeBFItxhW83gIH',
      production: 'gfOh1uYZrC4jtlW4ikWxPDgzVKo1FOoe'
    },
    persistApigeeClientId: { development: '', production: '' },
    setpayApigeeClientId: {
      development: '',
      production: ''
    },
    metaTagCardTitle: {
      en: 'Credit Card',
      es: 'Tarjeta de Crédito'
    },
    metaTagCardDescription: {
      en: `Log into your Synchrony Financial credit card account online to pay your bills, check your FICO score, sign up for paperless billing, and manage your account preferences`,
      es: `Ingrese a su cuenta de la Tarjeta de Crédito Synchrony Financial en línea para pagar sus facturas, revisar su puntuación FICO, inscribirse en facturas digitales y manejar su cuenta.`
    },
    languages: ['en', 'es'],
    vanityUrl: 'SynchronyBank.com',
    hostname: 'mastercard.syf.com',
    linkingRedirect: '',
    ivaKey: 'ae87d9ca-9c1d-4bd1-8fd3-e95fccb5cf6e',
    hasMss: true,
    hasCpl: false,
    promoUrl: '',
    hasCplOldErrorCode: false,
    isMultiAccount: false,
    footerContent: {
      en: 'Your Synchrony® Mastercard® is issued by Synchrony Bank. The Synchrony Bank Privacy Policy governs the use of the Synchrony® Mastercard®. The use of this site is governed by the use of the Synchrony Bank Internet Privacy Policy. The content and documents displayed may not all be provided in Spanish.',
      es: 'Synchrony Bank emite su Synchrony® Mastercard®. La Política de Privacidad de Synchrony Bank rige el uso de la Synchrony® Mastercard®. El uso de este sitio se rige por el uso de la Política de Privacidad de Internet de Synchrony Bank. Es posible que el contenido y los documentos que se muestran pueden no se proporcionen en español.'
    },
    phoneNumbers: {
      loan: '',
      dualcard: '1-800-944-7310',
      fraud: '1-855 389 2365',
      customerService: '1-800-944-7310',
      plcc: ''
    },
    iOSAppId: '',
    androidApp: {
      id: '',
      author: '',
      title: '',
      image: ''
    },
    crossBorder: false,
    cplHeroBannerDisplayName: '',
    termsOfService: {
      en: '/essimages/cs/groups/ess_webasset/generic/@tru/en/html/ess020096.html',
      es: '/essimages/cs/groups/ess_webasset/dualcard/@tru/es/html/ess020085.html'
    },
    onlinePrivacy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@tru/en/html/ess016898.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@tru/es/html/ess016895.html'
    },
    privacyPolicy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@tru/en/html/ess020095.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@tru/es/html/ess020090.html'
    },
    websiteUsage: {
      en: '/essimages/cs/groups/ess_webasset/generic/@tru/en/html/ess016918.html',
      es: '/essimages/cs/groups/ess_webasset/generic/@tru/es/html/ess016910.html'
    },
    voice: {
      cardName: '',
      google: {
        termsAndConditionsLink: ''
      },
      alexa: {
        termsAndConditionsLink: ''
      }
    }
  },
  palette: {
    button: {
      primary: {
        text: '#FFFFFF',
        hover: '#3b75d9'
      },
      secondary: {
        hover: '#e5efff'
      },
      background: '#448aff'
    },
    field: {
      icon: '#333333',
      focus: '#34657F',
      label: ''
    },
    progressStepBar: {
      fill: '#333333',
      label: '#333333'
    },
    progressBar: {
      complete: '',
      error: '#c63527',
      inProgress: '#0072ad',
      background: '#e9eaeb'
    },
    checkbox: {
      background: '#3E8529',
      font: '#FFFFFF'
    },
    switch: { background: '' },
    heroBackground: '#343642',
    bodyBackground: '#FFFFFF',
    iconBackground: '#CACACA',
    headerBackground: '#333333',
    modalBackground: '#ffffff',
    formBackground: '',
    headerDivider: '#343642',
    footerDivider: '#FBC600',
    contrastingText: '#ffffff',
    bodyText: '#333333',
    languageSelector: '#ffffff',
    focus: '#003d50',
    link: '#3E8529',
    footer: {
      background: '#ffffff',
      text: '#333333',
      link: '#333333'
    }
  },
  images: {
    logo: {
      en: '/assets/tru/logo.png',
      es: '/assets/tru/logo.png'
    },
    hero: '/assets/tru/background.png',
    heroBgDesktop: '',
    heroBgMobile: '',
    mainPromo: {
      en: '/assets/tru/promo.png',
      es: '/assets/tru/promo_es.png'
    },
    voiceCplLogo: ''
  }
}

export default tru
